import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"
import { useCurrencyFormatting } from "@nosto/preact"
import { transformRangeFacetData } from "../helpers";

export function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ${className}`}
            onClick={() => filter.remove()}
        >
            ×
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters();
    const { format } = useCurrencyFormatting();

    // console.log(filters);

    return (
        filters.length > 0 && (
            <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-filters-wrapper">
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map(filter => {
                        const isPriceFilter = filter.field === "price";
                        return (
                            <div
                                key={`${filter.name}: ${filter.value}`}
                                class="ns-selected-filter ns-d-flex ns-align-items-center fs-body-75"
                            >
                                <span class="ns-color-black">
                                    {isPriceFilter ? transformRangeFacetData(filter.value, format) : filter.value}
                                </span>
                                <FilterRemoveButton filter={filter} />
                            </div>
                        )
                    })}
                </div>
                <span
                    class="ns-anchor ns-text-align-right fs-body-75 ns-clear-all-filters-btn"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Clear Filters
                </span>
            </div>
        )
    )
}
